import { render, staticRenderFns } from "./StandingOrder.vue?vue&type=template&id=541af7ca&"
import script from "./StandingOrder.vue?vue&type=script&lang=js&"
export * from "./StandingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports